export const InscripcionProveedoresLang = {
    Titulo: {
        es: 'FORMATO DE INSCRIPCIÓN DE PROVEEDORES',
        en: 'VENDOR INSCRIPTION FORM',
    },
    codigoProveedor: {
        es: 'Código de proveedor',
        en: 'Vendor code',
    },
    informacionEmpresaTitle: {
        es: 'Información de la Empresa',
        en: 'Company information',
    },
    'NombreLegal': {
        'es': 'Nombre Legal',
        'en': 'Legal Name'
    },
    'NombreComercial': {
        'es': 'Nombre Comercial',
        'en': 'Business Name'
    },
    'NumIdentificacionTributaria': {
        'es': 'Número de Identificación Tributaria',
        'en': 'Taxpayer Identification Number (TIN)'
    },
    'Pais': {
        'es': 'País',
        'en': 'Country'
    },
    'Estado': {
        'es': 'Estado / Región',
        'en': 'State / Region'
    },
    'Ciudad': {
        'es': 'Ciudad',
        'en': 'City'
    },
    'DireccionComercial': {
        'es': 'Dirección Comercial',
        'en': 'Commercial Address'
    },
    'TelefonoRef': {
        'es': 'Número de teléfono de referencia',
        'en': 'Reference phone number'
    },
    'Email': {
        'es': 'Correo electrónico',
        'en': 'Email'
    },
    'actividadEconomica': {
        'es': 'Principal actividad económica',
        'en': 'Main economic activity'
    },
    'TipoFacturacion': {
        'es': 'Tipo de Factura',
        'en': 'Invoice Type'
    },
    'nombreCasaMatriz': {
        'es': 'Nombre de la casa matriz',
        'en': 'Headquarters name'
    },
    'distCasaMatriz': {
        'es': 'Si es distinto al nombre comercial.',
        'en': 'If it is different from the commercial name.'
    },
    'direccionCasaMatriz': {
        'es': 'Dirección de la casa matriz',
        'en': 'Headquarters address'
    },
    'distDireccionComercial': {
        'es': 'Si es distinto de la Dirección Comercial.',
        'en': 'If it is different from the Commercial Address.'
    },

    'completarCamposObligatorios': {
        'es': 'Completar los campos obligatorios.',
        'en': 'Complete the required fields.'
    },

    'informacionContactoRepresentanteLegal': {
        'es': 'Información de contacto del representante legal',
        'en': 'Contact information of the legal representative'
    },
    'Nombre': {
        'es': 'Nombre',
        'en': 'Name'
    },
    'inforamcionContactoCuentasCobrar': {
        'es': 'Información de contacto de cuentas por cobrar',
        'en': 'Accounts Receivable Contact Information'
    },
    'numeroTelefono': {
        'es': 'Número de teléfono',
        'en': 'Phone number'
    },
    'informacionBancaria': {
        'es': 'Información bancaria',
        'en': 'Bank information'
    },
    'numeroCuenta': {
        'es': 'Número de cuenta',
        'en': 'Account number'
    },
    'titularCuenta': {
        'es': 'Titular de cuenta',
        'en': 'Account holder'
    },
    'Banco': {
        'es': 'Banco',
        'en': 'Bank'
    },
    'tipoCuenta': {
        'es': 'Tipo de cuenta',
        'en': 'Account type'
    },
    'Moneda': {
        'es': 'Moneda',
        'en': 'Currency'
    },
    'bancoIntermediario': {
        'es': 'Banco Intermediario',
        'en': 'Intermediary bank',
    },
    'bancoBeneficiario': {
        'es': 'Banco Beneficiario',
        'en': 'Beneficiary bank',
    },
    'Direccion': {
        'es': 'Dirección',
        'en': 'Address'
    },
    'Swift': {
        'es': 'Swift',
        'en': 'Swift'
    },
    'ABA / BIN': {
        'es': 'ABA / BIN',
        'en': 'ABA / BIN'
    },
    'nombreBeneficiario': {
        'es': 'Nombre del Beneficiario',
        'en': 'Beneficiary Name'
    },
    'referenciasComerciales': {
        'es': 'Referencias Comerciales',
        'en': 'Commercial references'
    },
    'Referencia': {
        'es': 'Referencia',
        'en': 'Reference'
    },
    'adjuntarDocumentos': {
        'es': 'Adjuntar los siguientes documentos.',
        'en': 'Attach the following documents.'
    },
    'Documentation': {
        'es': 'Documentación',
        'en': 'Documentation'
    },
    'PermisoOperaciones': {
        'es': 'Permiso de operaciones',
        'en': 'Operations permit'
    },
    'escrituraConstitucion': {
        'es': 'Escritura de constitución',
        'en': 'Public Deed of Incorporation'
    },
    'zonaLibre': {
        'es': 'Opero en Zona Libre ',
        'en': 'I operate in a Free Zone'
    },
    'si': {
        'es': 'Si',
        'en': 'Yes'
    },
    'no': {
        'es': 'No',
        'en': 'No'
    },
    'nombreZona': {
        'es': 'Nombre Zona',
        'en': 'Zone Name'
    },
    'direccionZona': {
        'es': 'Dirección Zona',
        'en': 'Zone Address'
    },
    'registroExonerado': {
        'es': 'Registro exonerado',
        'en': 'Exempt registration'
    },
    'constPagosCuenta': {
        'es': 'Constancia de pagos a cuenta',
        'en': 'Proof of payments on account'
    },
    'noPermiso': {
        'es': 'NO TIENES PERMISOS PARA VER ESTA PÁGINA',
        'en': 'YOU DO NOT HAVE PERMISSIONS TO VIEW THIS PAGE'
    },
    'autorizacionPagos': {
        'es': `1) Por medio de la presente, declaramos que la información proporcionada en el presente formulario es correcta. Entendemos que “Prime Performance Fabrics, S.A de C.V”, podrá contactar a el departamento de cuentas por cobrar o contabilidad para su validación. Autorizamos a las empresas comerciales enumeradas en esta solicitud a proporcionar lo necesario para ayudar a "PPF" a establecer una relación comercial con nosotros.

        2) Entendemos que: la información bancaria proporcionada, ha sido verificada previo a ser compartida, por lo que “Prime Performance Fabrics, S.A de C.V” podrá emitir pagos a las mismas sin responsabilidad alguna por errores de escritura, siempre y cuando se utilice la información completada por nosotros.`,
        'en': 'Hereby, we declare that the above information is correct. We understand that "Prime Performance Fabrics, S.A de C.V", may contact or accounts receivables or accounting department for its validation. We Authorize the commercial companies listed in this application to disclose the necessary to help "PPF" to establish a commercial relationship.'
    },
    'guardarBorrador': {
        'es': 'Guardar Borrador',
        'en': 'Save Draft'
    },
    'guardar': {
        'es': 'Guardar',
        'en': 'Save'
    },
    'limpiar': {
        'es': 'Limpiar',
        'en': 'Clean'
    },
    'infCierta': {
        'es': 'La Información proporcionada en el presente formulario se considerará como cierta, por lo que nuestra responsabilidad únicamente se limita al analisis de la información proporcionada por el proveedor.',
        'en': 'The information provided in this form will be considered true, our accountability is limited to its analysis and validation only.'
    },
    'registroCompleto': {
        'es': 'Registro guardada correctamente.',
        'en': 'The information has been submitted successfully. '
    },
    'msgConfirmacion': {
        'es': '¿Estas seguro que deseas guardar la informacion?',
        'en': 'Are you sure about the entered information?'
    },
    'msgNoEditable': {
        'es': 'Una vez que lo envíe, puede comunicarse con un agente de PPF para permitir el acceso nuevamente si se requiere alguna corrección.',
        'en': 'Once you send it, you may contact a PPF agent to allow access again if any correction is required.'
    },
    'paisConstitucion': {
        'es': 'País de constitución',
        'en': 'Country of incorporation'
    },
    'siEsDistintoAnterior': {
        'es': 'Si es distinto al anterior',
        'en': 'If different from the previous one'
    },
    'ContactoCuentasPorCobrar': {
        'es': 'Contacto de cuentas por cobrar (persona encargada de confirmar pagos)',
        'en': 'Accounts receivable contact (person in charge of confirming payments)'
    },
    'representanteLegal': {
        'es': 'Representante legal',
        'en': 'Legal representative'
    },
    'nombreCompañia': {
        'es': 'Nombre de la compañia',
        'en': 'Company name'
    },
    'TelefonoSmall': {
        'es': 'Tel.',
        'en': 'Phone'
    },
    'nombreBanco': {
        'es': 'Nombre del banco',
        'en': 'Bank name'
    },
    'direccionBanco': {
        'es': 'Dirección del banco',
        'en': 'Bank address'
    },
    // 'declaracion': {
    //     'es': 'Declaro que la información anterior es correcta. Entiendo que "Pride Performance Fabrics, S.A de C.V" podrá contactar y/o utilizar otras fuentes que le permitan investigar la información credicia que considere necesaria para este fin. Autorizamos a las empresas comerciales que figuran en esta solicitud a proveer lo necesario para ayudar a "Pride Performance Fabrics, S.A de C.V", a establecer una línea de crédito.',
    //     'en': 'I declare that the above information is correct. I understand that "Pride Performance Fabrics, S.A de C.V", may contact and / or use other sources to enable it to investigate credit information deemed necessary for this purpose. Autorize commercial companies listed in this application to disclose the necessary to help "Pride Performance Fabrics, S.A de C.V", to establish a line of credit.'
    // },
    'msgContacto': {
        'es': '*Si tiene alguna duda con respecto a algún espacio, por favor escriba o llame al',
        'en': '*If you have any doubt regarding any blank to fill, please write or call to'

    },

    'msgValidacion': {
        'es': '*Esta información es muy importante. Los datos bancarios se validarán mediante llamada telefónica al recibir el formulario completo.',
        'en': '*This information is strongly required. After receiving this form, we will contac the accounts receivables executive.'
    },
    'msgValidacionNacional': {
        'es': 'Autorizo a la empresa Prime Perfomance Fabrics, S. A. de C.V. (PPF) con RTN 05019013550285, con la que tengo relación como proveedor a realizar los depósitos correspondientes a los pagos por concepto de productos entregados y/o servicios prestados.',
        'en': 'I authorize the company Prime Perfomance Fabrics, S. A. de C.V. (PPF) with RTN 05019013550285, with whom I have a relationship as a supplier to make the deposits corresponding to the payments for the products delivered and / or services provided.'
    },
    'parte': {
        'es': 'PARTE',
        'en': 'PART'
    },
    'informacionGeneral': {
        'es': 'Información general',
        'en': 'General information'
    },
    'tipoSolictud': {
        'es': 'Tipo de solicitud',
        'en': 'Type of request'
    },
    'Inscripción': {
        'es': 'Inscripción',
        'en': 'Registration'
    },
    'Actualización': {
        'es': 'Actualización',
        'en': 'Update'
    },
    'cuentaBancariaNacional': {
        'es': 'Dichos depósitos deberán efectuarse en la cuenta No.',
        'en': 'Such deposits must be made in account No.'
    },
    'RTN': {
        'es': 'RTN de la empresa',
        'en': 'Company RTN'
    },
    'CorreoNotificacionPago': {
        'es': 'Correo electrónico para notificación de pagos',
        'en': 'Email for payment notification'
    },
    'Imprimir': {
        'es': 'Imprimir',
        'en': 'Print'
    },
    'ArchivoActual': {
        'es': 'Archivo actual',
        'en': 'Current file'
    },
    'agregarFormatoInscripcion': {
        'es': 'Agregar Formato de inscripción:',
        'en': 'Add Registration Form:'
    },
    'archivoGuardado': {
        'es': 'Archivo guardado',
        'en': 'File saved'
    },
    'descargarArchivoAcutal': {
        'es': 'Descargar archivo actual',
        'en': 'Download current file'
    },
    'aNombreDe': {
        'es': 'A nombre de',
        'en': 'In favor of'
    },
    'ErrorArchivoTamaño': {
        'es': 'No se permiten archivos de 5MB o más.',
        'en': 'Files of 5MB or more are not allowed.'
    },
    'Factura': {
        'es': 'Factura',
        'en': 'Invoice'
    },
    'inforamcionContactoFinanzas': {
        'es': 'Información contacto finanzas',
        'en': 'Finance contact information'
    },
    'Contacto': {
        'es': 'Contacto',
        'en': 'Contact'
    },
    "informacionFinanciera": {
        "es": "Información financiera",
        "en": "Financial information"
    },
    "Activos": {
        "es": "Activos",
        "en": "Assets"
    },
    "Pasivos": {
        "es": "Pasivos",
        "en": "Liabilities"
    },
    "ActivosCorrientes": {
        "es": "Activos corrientes",
        "en": "Current assets"
    },
    "TotalActivos": {
        "es": "Total activos",
        "en": "Total assets"
    },
    "PasivosCorrientes": {
        "es": "Pasivos corrientes",
        "en": "Current liabilities"
    },
    "TotalPasivos": {
        "es": "Total pasivos",
        "en": "Total liabilities"
    },
    "RegistroExonerado": {
        "es": "Número Registro Exonerado",
        "en": "Exonerated Registration Number"
    },
    "FechaVencimiento": {
        "es": "Fecha Vencimiento",
        "en": "Expiration Date"
    },
    "FechaInicio": {
        "es": "Fecha Inicio",
        "en": "Start Date"
    },
    "tieneConstanciaPagos": {
        "es": "Cuento con Constancia de Pagos a Cuenta vigente",
        "en": "I have a current Certificate of Payments on Account"
    },
    "Revisar": {
        "es": "Revisar",
        "en": "Review"
    },
    'msgConfirmacionIncompleta': {
        'es': '¿Estas seguro que deseas guardar la información Incompleta?',
        'en': 'Are you sure you want to save incomplete information?'
    },

    'msgNoEditableIncompleta': {
        'es': 'La inscripción se completará exitosamente una vez que haya proporcionado toda la información requerida.',
        'en': 'The registration will be successfully completed once you have provided all the required information.'
    },
    "text0PBancos": {
        'es': 'Actualice sus datos bancarios',
        'en': 'Update your banking information'
    },
    "textPBancos": {
        'es': 'Los pagos se realizarán únicamente a cuentas registradas a su nombre según su tipo:',
        'en': 'Payments will be made only to accounts registered under your name, according to your category:'
    },
    "text2PBancos": {
        "es": "Esta actualización es obligatoria por la Ley Contra el Lavado de Activos (Decreto 67-2013).",
        "en": "This update is mandatory under the Anti-Money Laundering Law (Decree 67-2013)."
    },
    "text3PBancos": {
        "es": "1.- Empresas (sociedades): Cuenta a nombre de la empresa.",
        "en": "1.- Companies (corporations): Account must be under the company’s name."
    },
    "text4PBancos": {
        "es": "2.- Personas naturales/comerciantes individuales: Cuenta a su nombre personal.",
        "en": "2.- Individuals/sole proprietors: Account must be under your personal name."
    },
    "text5PBancos": {
        "es": "Al enviar este formulario, usted confirma que:",
        "en": "By submitting this form, you confirm that:"
    },
    "text6PBancos": {
        "es": `"La cuenta bancaria pertenece legalmente a mi empresa/persona y cumple con los requisitos de la Ley hondureña”.`,
        "en": `"The bank account legally belongs to my company/myself and complies with the requirements of Honduran law."`
    },
    "text7PBancos":{
        "es": `Para poder procesar los pagos el banco de enviar una constancia bancaria con la información de su cuenta al correo de adminsitracion@ppf.com.hn`,
        "en": `In order to process payments, the bank must send a bank statement with your account information to the email address administracion@ppf.com.hn`
    },
    "textCondicion": {
        'es': "Elija cómo recibir sus pagos:",
        'en': 'Choose how to receive your payments:'
    },
    "text1Condicion": {
        'es': "(Si su cuenta NO está en Banco Atlántida o Ficohsa)",
        'en': '(If your account is NOT with Banco Atlántida or Ficohsa)'
    },
    "text2Condicion": {
        'es': "Atención:",
        'en': 'Attention:'
    },
    "text3Condicion": {
        'es': "Por políticas financieras, no hacemos transferencias a otros bancos (excepto Atlántida/Ficohsa).",
        'en': 'Due to financial policies, we do not process transfers to banks other than Banco Atlántida or Ficohsa'
    },
    "opciones": {
        'es': "Tiene dos opciones para recibir su dinero:",
        'en': 'You have two options to receive your funds:'
    },
    "opcion1": {
        'es': "Opción 1:",
        'en': 'Option 1:'
    },
    "opcion1Text": {
        'es': "Transferencia a instituciones bancarias distintas a Banco Atlántida o Ficohsa.",
        'en': 'Transfer to financial institutions other than Banco Atlántida or Ficohsa.'
    },
    "opcion2": {
        'es': "Opción 2:",
        'en': 'Option 2:'
    },
    "opcion2Text": {
        'es': "Retiro de cheque en nuestras oficinas.",
        'en': 'Check pickup at our offices.'
    },
    "Acepto": {
        'es': "Acepto la deducción de la comisión bancaria que aplique su banco.",
        'en': 'Accept the deduction of the bank fee charged by your bank.'
    },
    "PagarCheque": {
        'es': "Acepto recibir pagos mediante cheque.",
        'en': 'I agree to receive payments by check.'
    },
    "compromiso": {
        'es': "Compromisos:",
        'en': 'Commitments:'
    },
    "compromisoText": {
        'es': "1.- Un representante autorizado (con identificación) retirará el cheque personalmente.",
        'en': '1.- An authorized representative (with identification) will personally collect the check.'
    },
    "compromisoText2": {
        'es': "2.- El cheque se emitirá solo a nombre del titular registrado (empresa o persona natural).",
        'en': '2.- The check will be issued only in the name of the registered account holder (company or individual).'
    },
    "textBancosInter": {
        'es': "Complete sus datos bancarios internacionales",
        'en': 'Complete your international banking information:'
    },
    "text1BancosInter": {
        'es': "Importante para pagos internacionales.",
        'en': 'Important for international payments.'
    },
    "text2BancosInter": {
        'es': `Los pagos se realizarán solo a cuentas registradas a nombre de su empresa según su tipo:`,
        'en': 'Payments will be made only to accounts registered under your name, according to your category:'
    },
    "text3BancosInter": {
        'es': `1.- Empresas (sociedades mercantiles): Cuenta a nombre de la empresa.`,
        'en': '1.- Companies (corporations): Account must be under the company’s name.'
    },
    "text4BancosInter": {
        'es': `2.- Personas naturales: Cuenta a su nombre personal.`,
        'en': '2.- Individuals/sole proprietors: Account must be under your personal name'
    },
    "text5BancosInter": {
        'es': `3.- Todos los datos deben coincidir con sus documentos legales.`,
        'en': ''
    },
    "text6BancosInter": {
        'es': `"La información bancaria es correcta y cumple con las leyes antifraude de mi país."`,
        'en': `"The banking information is accurate and complies with the anti-fraud laws of my country."`
    },
    "notasClave": {
        'es': `Notas Clave:`,
        'en': 'Key Notes:'
    },
    "notasText1": {
        'es': `1.- Para empresas:`,
        'en': '1.- For companies:'
    },
    "notasText2": {
        'es': `Adjunte copia del certificado de registro mercantil.`,
        'en': 'Attach a copy of the commercial registration certificate.'
    },
    "notasText3": {
        'es': `2.- Para personas naturales:`,
        'en': '2.- For natural persons:'
    },
    "notasText4": {
        'es': `Adjunte copia de su pasaporte o identificación oficial.`,
        'en': 'Attach a copy of your passport or official ID.'
    },
    'marcarOpcion': {
        'es': 'Es requerido seleccionar una opción.',
        'en': 'You are required to select an option.'
    },
    'msjZonaLibre': {
        'es': '***** Si no presento la Constancia de Pagos a Cuenta o el Registro de Exonerado vigente según sea aplicable, se realizarán las retenciones fiscales correspondientes, conforme a la legislación tributaria de Honduras. *****',
        'en': '***** If I do not present the current Certificate of Payment on Account or the Exonerated Person Registration, as applicable, the corresponding tax withholdings will be made, in accordance with Honduran tax legislation. *****'
    },
    "regExonerado": {
        'es': `No cuento con Registro de Exonerados vigente`,
        'en': 'I do not have a valid Exonerated Registry.'
    },
    "ayuda": {
        'es': `¿Necesita ayuda?`,
        'en': 'Need help?'
    },
    "ayudaText": {
        'es': `Si tiene dudas o necesita asistencia, puede comunicarse con nosotros a través de los siguientes medios:`,
        'en': 'If you have any questions or need assistance, please contact us using the following methods:'
    },
    "telefono": {
        'es': 'Telefono:',
        'en': 'Phone:'
    },
    "email": {
        'es': 'Correo:',
        'en': 'Email:'
    },
    "pasaporte": {
        'es': `Pasaporte/Certificado`,
        'en': 'Passport/Certificate'
    },
    "declaracion": {
        'es': "Declaración de situación fiscal:",
        'en': 'Fiscal Status Declaration:'
    },
    "declaracionP": {
        'es': "Atención, según legislación hondureña (Art. 37-A Código Tributario), si no presenta alguno de estos documentos vigentes:",
        'en': 'Attention, according to Honduran legislation (Art. 37-A Tax Code), if you do not submit any of these valid documents:'
    },
    "regExoneradoT": {
        "es": '•	Registro de Exonerados (SEFIN)  ',
        "en": '• Exonerared Registry (SEFIN)'
    },
    "constPagosT": {
        "es": '•	Constancia de Pagos a Cuenta (SAR)',
        "en": '• Constancy of paymnets on account (SAR)'
    },
    "declaracionP2": {
        'es': `Aplicaremos retenciones impositivas automáticas.  `,
        'en': 'We will apply taxes in accordance with Honduran legislation. '
    },
    "InformacionGuardada": {
        'es': 'Información guardada correctamente.',
        'en': 'Information saved successfully.'
    },
    "msgIncompleta": {
        'es': 'La información se ha guardado como incompleta. Por favor, complete los campos requeridos para finalizar la inscripción.',
        'en': 'The information has been saved as incomplete. Please complete the required fields to finalize the registration.'
    },
    "InformacionFaltante": {
        'es': 'Información faltante',
        'en': 'Missing information'
    },
    "Cerrar": {
        'es': 'Cerrar',
        'en': 'Close'
    },
    actualizarCampos: {
        'es': 'Actualizar situación fiscal',
        'en': 'Update Tax Status'
    },
    BancoPais: {
        es: 'Banco Pais',
        en: 'Country Bank'
    },
    NotaSubirArchivo: {
        'es': 'Una vez finalizado el ingreso de la información, deberá descargar el formato de inscripción en el botón de Imprimir, firmarlo y sellarlo. Posteriormente, deberá adjuntarlo en la sección “Seleccionar archivo” para subir el documento.',
        'en': 'Once the information entry has been completed, you must download the registration form using the “Print” button, sign and stamp it. Afterwards, you must upload it by attaching the file in the “Select File” section.'
    },
    AgregarRegistro:{
        es:'Agregar Registro',
        en:'Add Record'
    },
    Nota:{
        es:'Nota:',
        en:'Note:'
    }
}